import { connect } from 'react-redux';
import { Url } from '@wix/da-url';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  getProfileOwnerStats,
  getProfileOwnerTagline,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';

export default connect(
  (state: AppState) => {
    const profileOwnerUser = getProfileOwnerUser(state);
    return {
      profileOwnerUser,
      tagline: getProfileOwnerTagline(state),
      stats: getProfileOwnerStats(state),
      isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
      url: Url.userLink(profileOwnerUser.username),
    };
  },
  {}
);
